<template>
  <v-hover>
    <template #default="{ isHovering, props }">
      <v-card
        v-bind="props"
        width="250"
        :variant="isHovering ? 'elevated' : 'flat'"
        :elevation="isHovering ? 8 : 0"
        class="card pa-4"
        @click="selectCard()"
      >
        <v-img
          class="layer-card-image"
          :src="layer.urlMap.image"
          height="127"
          cover
          rounded
          @load="loadingImage = false"
        >
          <!-- v-img default slot overlays the image; flex utils center the content -->
          <div class="d-flex align-center justify-center fill-height">
            <v-progress-circular
              v-show="loadingImage"
              :size="25"
              :width="5"
              indeterminate
              color="primary"
            />
            <v-chip
              v-if="isSelected"
              prepend-icon="mdi-check"
              class="added-text"
            >
              Added
            </v-chip>
            <v-btn
              v-else-if="isHovering"
              color="primary"
              variant="flat"
              icon="mdi-plus"
            />
          </div>
        </v-img>
        <v-card-title class="card-title pl-1 py-1 pr-0">
          {{ layer.name }}
        </v-card-title>
        <v-card-subtitle
          class="card-text pl-1 pr-0"
        >
          {{ layer.description }}
        </v-card-subtitle>
      </v-card>
    </template>
  </v-hover>
</template>

<script>
import {mapState, mapActions} from 'vuex';

export default {
  name: 'LayerCard',
  props: {
    layer: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      loadingImage: true,
    };
  },
  computed: {
    ...mapState('layers', ['userLayers']),
    isSelected() {
      return this.userLayers?.some((layer) => layer.id === this.layer.id);
    },
  },
  methods: {
    ...mapActions('layers', ['toggleUserLayer']),
    selectCard() {
      // As of July 22nd, 2024 the new layer menu only exists in internal maps.
      // If we want this functionality to work in external maps, we will have to make sure to
      // add `userLayers` and `toggleUserLayer` to the external layers store.
      this.toggleUserLayer?.(this.layer);
    },
  },
};
</script>

<style scoped lang="scss">
.card {
  cursor: pointer;
  white-space:normal;

  &-title {
    font-size: 1rem;
    white-space: normal;
  }
  &-text {
    white-space: normal;
  }
}

.added-text {
  background-color: rgba(0, 0, 0, 0.5);
  color: white;
}
</style>
